import { LatLng, PolygonItemUI, Polygons, PolygonSchema } from 'types/maps';

export const DEFAULT_POLY_OPTIONS: NonNullable<PolygonItemUI['options']> = {
  strokeColor: '#FF0000',
  strokeWeight: 2,
  fillColor: '#FF0000',
  fillOpacity: 0.2,
};

const ringsEqual = (a: PolygonSchema, b: PolygonSchema) =>
  a.length === b.length &&
  a.every((p, i) => p.lat === b[i].lat && p.lng === b[i].lng);

export function updatePolygonsFromMap(
  prev: PolygonItemUI[],
  incoming: Polygons
): PolygonItemUI[] {
  let changed = false;
  const len = Math.min(prev.length, incoming.length);
  const next = prev.slice();

  for (let i = 0; i < len; i++) {
    const oldP = prev[i];
    const newPaths = incoming[i].paths;
    if (!ringsEqual(oldP.paths, newPaths)) {
      next[i] = { ...oldP, paths: newPaths };
      changed = true;
    }
  }

  return changed ? next : prev;
}

export function rectangleAround(
  center: LatLng,
  halfWidthMeters: number,
  halfHeightMeters: number
): PolygonSchema {
  const { lat, lng } = center;

  // Aproximaciones geodésicas locales:
  // 1° lat ≈ 110.574 km
  // 1° lng ≈ 111.320 * cos(lat) km
  const kmPerDegLat = 110.574;
  const kmPerDegLng = 111.32 * Math.cos((lat * Math.PI) / 180);

  const dLat = halfHeightMeters / 1000 / kmPerDegLat;
  const dLng = halfWidthMeters / 1000 / kmPerDegLng;

  const nw: LatLng = { lat: lat + dLat, lng: lng - dLng };
  const ne: LatLng = { lat: lat + dLat, lng: lng + dLng };
  const se: LatLng = { lat: lat - dLat, lng: lng + dLng };
  const sw: LatLng = { lat: lat - dLat, lng: lng - dLng };

  return [nw, ne, se, sw];
}

export async function cityToCountryCode(city: string) {
  const mod = await import('city-timezones');
  const api = mod.default ?? mod;
  const matches = api.lookupViaCity(city.trim());
  if (!matches.length) return null;
  return matches[0].iso2 ?? null;
}
